import React, { useState, useEffect } from 'react';
import Table from '../../Components/Table';
import { FacilityTypeColumns } from '../../ColumnsConfig/FacilityTypeColumns';
import './../../App.css';
import { Box, Button, IconButton, InputBase, Paper, Chip} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import FacilityTypeFormDialog from '../../Modals/FacilityTypeFormDialog';
import ConfirmationModal from '../../Common/ConfirmationModal';
import loaderGif from '../../Assests/loader.gif';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import FacilityTypeService from '../../Services/FacilityType';

const FacilityType = () => {
  const [rows, setRows] = useState([]); // Facility types from API
  const [searchValue, setSearchValue] = useState('');
  const [chipValue, setChipValue] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState (1); // Track current page
  const [pageSize, setPageSize] = useState(10); // Track page size
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalRecords, setTotalRecords] = useState (0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortColumn] = useState(''); 
  const [order, setSortOrder] = useState("asc"); 
  const [recordDeleted, setRecordDeleted] = useState(false); 
  const [deleteError, setDeleteError] = useState(false);
  const [createRecord, setCreateRecord] = useState(false); 
  const [createRecordError, setCreateRecordError] = useState(false); 
  const [updateRecord, setUpdateRecord] = useState(false); 
  const [updateRecordError, setUpdateRecordError] = useState(false); 
  const [facilityName, setFacilityName] = useState('');
const validSortFields = ['name', 'description'];

const fetchFacilityTypes = async (
  page = currentPage,
  size = pageSize,
  sortByField = sortBy,
  sortOrder = order,
  searchTerm = facilityName
) => {
  setIsLoading(true);
  try {
    const queryObj = {
      page,
      pageSize: size,
      sortBy: validSortFields.includes(sortByField) ? sortByField : 'name',
      order: sortOrder,
      searchTerm: searchTerm.trim() || "",
    };

    const response = await FacilityTypeService.fetchFacilityTypes(
      queryObj.page,
      queryObj.pageSize,
      queryObj.sortBy,
      queryObj.order,
      queryObj.searchTerm,
    );

    const { data, totalRecords, totalPages } = response;

    if (Array.isArray(data)) {
      setRows(data.map(row => ({ ...row, id: row.facility_type_id })));
      setTotalRecords(totalRecords);
      setTotalPages(totalPages);
    } else {
      throw new Error('Unexpected API response format.');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.ErrorMessage || "Failed to fetch Facility data.";
    console.error('Failed to fetch Facility data:', errorMessage);
    NotificationManager.error(errorMessage, "Error", 5000);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  fetchFacilityTypes();
}, [currentPage, pageSize]);
  useEffect(() => {
    if (recordDeleted || deleteError || createRecord || createRecordError || updateRecord ||updateRecordError ) {
      const timer = setTimeout(() => {
        setRecordDeleted(false);
        setDeleteError(false);
        setCreateRecord(false);
        setCreateRecordError(false);
        setUpdateRecord(false);
        setUpdateRecordError(false)
    
      }, 5000); // Hide alert after 5 seconds
      return () => clearTimeout(timer); // Cleanup timer if component unmounts
    }
  }, [recordDeleted, deleteError,createRecord,createRecordError,updateRecord]);
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };
  const handleSearch = () => {
    const trimmedSearchTerm = facilityName.trim(); 
    setChipValue(trimmedSearchTerm);
    fetchFacilityTypes(1, pageSize, sortBy, order, trimmedSearchTerm); 
  };

  const handleChipDelete = async() => {
    setChipValue('');
    try{
      await fetchFacilityTypes(1, pageSize, sortBy, order, '');
  
    }catch(error){
      console.error('Error fetching SCAC data:', error);
      //NotificationManager.error("Failed to fetch SCAC data.", "Error", 5000);
    }finally{
      setFacilityName('');
    }
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);  // Update current page
    setPageSize(size);      // Update page size
  };
  
  const handleDialogOpen = () => {
    setInitialData(null);
    setIsDialogOpen(true);
  };
  const handleDialogClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setIsDialogOpen(false);
    }
  };
  const handleSave = async (formData) => {
    setIsLoading(true); // Show loading spinner while saving data
    try {
      const { facility_type_id,name, description } = formData;
  
      if (facility_type_id) {
        // Update existing facility type
        const updateData = {name,description }; // Only send the required fields
        await FacilityTypeService.updateFacilityTypes(facility_type_id, updateData) 
        setUpdateRecord(true);
        NotificationManager.success("Facility type Updated successfully.", "Success", 3000);
        console.log('Updated facility type:', updateData);
        setUpdateRecord(false);
      } else {
        // Create new facility type
        const newFacilityType = {
          description: formData.description,
          name: formData.name
        };
        await FacilityTypeService.createFacilityTypes( newFacilityType)
        NotificationManager.success("Facility type saved successfully.", "Success", 3000);
      }
  
      fetchFacilityTypes(); // Refresh the table data
      setCreateRecord(true);
      setIsDialogOpen(false); // Close the dialog
    
      
    } catch (error) {
      console.error('Error saving facility type:', error);
      if (error.response) {
        // Handle HTTP errors
        if (error.response.status === 400) {
          NotificationManager.warning("Please check your inputs.", "Bad Request", 5000);
        } else if (error.response.status === 404) {
          NotificationManager.info("Resource not found.", "Not Found", 5000);
        } else if (error.response.status === 500) {
          NotificationManager.error("Server error. Please try again.", "Internal Server Error", 5000);
        } else {
          NotificationManager.error(`Error: ${error.message}`, "Save Failed", 5000);
        }
      } else if (error.request) {
        // Handle network errors
        NotificationManager.error("No response from the server. Please check your connection.", "Network Error", 5000);
      } else {
        // Handle unknown errors
        NotificationManager.error(`Error: ${error.message}`, "Save Failed", 5000);
      }
    }
  
    setIsLoading(false); // Hide loading spinner when saving data
  };
  

  const handleEdit = (rowData) => {
    setInitialData(rowData);
    setIsDialogOpen(true);
  };
  const handleSort = (field, order) => {
    setSortColumn(field);
    setSortOrder(order);
    fetchFacilityTypes(1, pageSize, field, order);
  };
  // Delete Facility Type
  const handleDelete = (rowData) => {
    setRowToDelete(rowData);
    setIsDeleteModalOpen(true);
  };
  const handleConfirmDelete = async () => {
    setIsLoading(true); // Show loading spinner while deleting data
    try {
      const facility_type_id = rowToDelete.facility_type_id;
      await FacilityTypeService.deleteFacilityTypes(facility_type_id);
      setRows(rows.filter((row) => row.facility_type_id !== rowToDelete.facility_type_id));
      setIsDeleteModalOpen(false);
      setRecordDeleted(true);
      
      NotificationManager.success("Facility Deleted successfully.", "Success", 3000);
      setIsDialogOpen(false); // Close the modal after successful save
      fetchFacilityTypes();
    } catch (error) {
      console.error('Error deleting facility type:', error);
      console.log("error update-------",error);
      console.error('Error updating data:', error.message);
      if (error.message.includes("400")) {
        NotificationManager.warning("Please check your inputs.", "Bad Request", 5000);
      } else if (error.message.includes("404")) {
        NotificationManager.info("Resource not found.", "Not Found", 5000);
      } else if (error.message.includes("500")) {
        NotificationManager.error("Server error. Please try again.", "Internal Server Error", 5000);
      } else {
        NotificationManager.error(`Error: ${error.message}`, "Save Failed", 5000);
      }
    }
    setIsLoading(false); // Hide loading spinner when deleting data
  };
  
  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };
  return (
    <div className='px-5 my-1'>
        <div>
   
   <NotificationContainer />
 </div>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center">
          <Paper component="form" className="search-container" onSubmit={(e) => e.preventDefault()}>
            <InputBase
              className="search-input"
              placeholder="Search Facility Types"
              inputProps={{ 'aria-label': 'search facility types' }}
              value={facilityName}
              onChange={(e) => setFacilityName(e.target.value)}
            />
            <IconButton type="button" aria-label="search" onClick={handleSearch}>
              <SearchIcon />
            </IconButton>
          </Paper>
          {chipValue && (
            <Chip
              label={chipValue}
              onDelete={handleChipDelete}
              deleteIcon={<CloseIcon />}
              className="chip-style"
            />
          )}
        </Box>
        <Button
          variant="contained"
          onClick={handleDialogOpen}
          className='add-new-btn'
        >
          Add New Facility Type
        </Button>
      </Box>
      <Box position="relative" mt={2}>
        {isLoading && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(255, 255, 255, 0.8)"
            zIndex={1}
          >
            <img src={loaderGif} alt="Loading..." width={50} height={50} />
          </Box>
        )}
        
      
      <Table
        rows={rows}
        columns={FacilityTypeColumns(handleEdit, handleDelete)}
        className='table-header'
        currentPage={currentPage}
        pageSize={pageSize}
        totalRecords={totalRecords}
        onPageChange={handlePageChange}
        totalPages={totalPages}
        onSort={handleSort}// Use actual data length
      />
      </Box>
      <FacilityTypeFormDialog
        open={isDialogOpen}
        handleClose={handleDialogClose}
        handleSave={handleSave}
        initialData={initialData}
      />
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        message="Are you sure you want to delete this Facility Type?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </div>
  );
};
export default FacilityType;